module.exports = __webpack_public_path__ + "img/CosmopolitanScript-Regular.6c73803c.svg";